import PropTypes from 'prop-types';

import { DASHBOARD_ITEM_API_NAMES } from '@src/constants/commons';

import { filtersProptype } from 'packages/utils/proptypes/charts';
import { tablePropType } from 'packages/utils/proptypes/dashboard/tableCard';

import DashboardWidget from '../DashboardWidget';
import { deviationsFromTaskCompliance, tableDashboardConfig } from '../DashboardWidget/configs';
import styles from './styles.module.less';

const TableCard = ({
  table,
  refresh,
  filters,
  onEdit,
  elementsRef,
  eventTypes,
  onDownloadCsv,
  ...props
}) => {
  const tableDashboard = tableDashboardConfig({
    eventTypes,
    elementsRef,
    onDownloadCsv,
    className: styles.tableCard,
    ...props,
  });

  const configs = {
    [DASHBOARD_ITEM_API_NAMES.TABLE_DASHBOARD]: tableDashboard,
    [DASHBOARD_ITEM_API_NAMES.EXECUTION_RECORDS_DASHBOARD]: deviationsFromTaskCompliance,
  };

  return (
    <DashboardWidget
      widget={table}
      onEdit={onEdit}
      refresh={refresh}
      filters={filters}
      config={configs[table?.apiName || DASHBOARD_ITEM_API_NAMES.TABLE_DASHBOARD] || tableDashboard}
    />
  );
};

TableCard.propTypes = {
  table: tablePropType.isRequired,
  refresh: PropTypes.bool.isRequired,
  filters: filtersProptype.isRequired,
  onEdit: PropTypes.func.isRequired,
  elementsRef: PropTypes.object.isRequired,
  eventTypes: PropTypes.array,
  onDownloadCsv: PropTypes.func,
};

export default TableCard;
